import React from "react";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import AuthenticateProvider from "./Contexts/AuthenticateProvider";
import NotificationProvider from "./Contexts/NotificationProvider";
import SocketPresenceProvider from "./Contexts/SocketPresenceProvider";
import Routers from "./Routers";
import UnAuthorized from "./Components/UnAuthorized";
import FullScreenLoader from "./Components/PageLoading";

// Push, the bell and the inbox live in NotificationProvider. It sits inside the auth provider so
// it only runs when someone is really signed in (the Redux "auth" flag starts as true even on the
// login page, so it cannot be used for that).
function App() {
    const component = useSelector((state) => state.component);
    return (
        <>
            <FullScreenLoader />
            <AuthenticateProvider>
                <NotificationProvider>
                    <SocketPresenceProvider>
                        {component?.auth ? <Routers /> : <UnAuthorized />}
                    </SocketPresenceProvider>
                </NotificationProvider>
            </AuthenticateProvider>
            <ToastContainer theme="dark" autoClose={2000} position="top-right" />
        </>
    );
}

export default App;
